import { render } from "./system-button.vue?vue&type=template&id=2b804eef&scoped=true"
import script from "./system-button.vue?vue&type=script&lang=js"
export * from "./system-button.vue?vue&type=script&lang=js"

import "./system-button.vue?vue&type=style&index=0&id=2b804eef&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b804eef"]])

export default __exports__